export default __webpack_public_path__ + "static/media/sample_jetso.baff18c3.png";